import React, { useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useMutation } from '@apollo/react-hooks';
import toast from 'react-hot-toast';
import ReactTooltip from 'react-tooltip';
import colors from '../../styles/colors';
import Input from '../Input';
import Button from '../Button';
import { ADD_CONTACT_TAG } from '../../graphql/queries';
import Icon from '../Icon';
import { IconEnum } from '../Icons';

const MessageDetails = styled.div`
  display: flex;
  font-size: 1.2rem;
  color: ${colors.grey3};
  padding: 0 5px;
  width: 100%;
`;

const TooltipStyles = createGlobalStyle`

.__react_component_tooltip{
      display: inline-block !important;
      max-width: 300px;
    }
`;

const ShortCodeContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
`;

const Form = styled.form`
  padding: 20px 15px;
  max-width: 300px;
  width: calc(75vw - 20px);
`;

export default function AddContactTagModal({ close }) {
  const [tagValue, setTagValue] = useState('');
  const [error, setError] = useState('');
  const [addContactTag, { loading: addTagLoading }] = useMutation(
    ADD_CONTACT_TAG,
    {
      onCompleted() {
        toast.success('Successfully Added');
        close();
      },
    },
  );

  const setValidateTagValue = (e) => {
    const { value } = e.target;
    const regex = /^[a-z0-9-]{1,}$/;
    const isValid = regex.test(value);
    setTagValue(value);
    if (isValid) {
      return setError('');
    }
    setError(
      'Tags should contain only lower-case letters, numbers, and hyphens (no other special characters or spaces allowed)',
    );
  };

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <TooltipStyles />
      <>
        <div
          style={{
            display: 'flex',
            padding: '10px 0',
            alignItems: 'center',
          }}
        >
          <div
            style={{ display: 'flex', alignItems: 'center' }}
            data-tip="Tags should contain only lower-case letters, numbers, and hyphens (no other special characters or spaces allowed)."
          >
            <MessageDetails>Contact Tag</MessageDetails>{' '}
            <Icon size={10} margin="0 5px" icon={IconEnum.infoRegular} />
          </div>
        </div>
        <ShortCodeContainer>
          <Input
            top
            type="text"
            // header="Short Code"
            onChange={setValidateTagValue}
            value={tagValue}
            margin="0px 0px 0px 0px"
            width="100%"
          />

          <Button
            margin="20px 0 0 0"
            width="200px"
            text="Add Tag"
            loading={addTagLoading}
            type="button"
            onClick={() => {
              if (!error && tagValue) {
                addContactTag({
                  variables: {
                    tags: [tagValue],
                  },
                });
              } else if (tagValue.length < 1) {
                toast.error("Contact tag can't set to be empty");
              } else {
                toast.error('Please enter a valid contact tag');
              }
            }}
          />
        </ShortCodeContainer>
        <div
          style={{
            color: 'red',
            fontSize: '13px',
            padding: '0 0 10px',
            display: 'flex',
            width: '100%',
          }}
        >
          {error}
        </div>
      </>
      <ReactTooltip
        place="right"
        type="dark"
        effect="solid"
        clickable={false}
      />
    </Form>
  );
}
